import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AppStoreRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    // Get incoming parameters
    const incomingParams = new URLSearchParams(location.search);
    const incomingCt = incomingParams.get('ct');

    // Construct ct parameter
    const ct = incomingCt 
      ? `WebsiteRedirect-${incomingCt}`
      : 'WebsiteRedirect';

    // Construct the final URL with fixed parameters
    const finalUrl = 'https://apps.apple.com/app/id6738414239' + 
      '?pt=1048578458' +
      '&mt=8' +
      '&utm_source=website' +
      '&utm_campaign=downloads' +
      '&utm_medium=internal' +
      `&ct=${encodeURIComponent(ct)}`;

    window.location.href = finalUrl;
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-lg">Redirecting to App Store...</p>
    </div>
  );
};

export default AppStoreRedirect; 